import _ from 'lodash'
import {sanitizeVal} from './query_matching'

const indexedRecordsCache = new WeakMap()

export const getIndexedCandidates = (entities, keys, query) => {
	const key = keys.find(key => isIndexableKey(key) && isIndexableQueryValue(query[key]))
	if (!key) return null

	const index = getIndexForKey(entities, key)
	return createCollectionLike(entities, getRecordsFromIndex(index, query[key]))
}

export const getRecordsFromIdIndex = (entities, ids) => {
	const index = getIndexForKey(entities, 'id')
	const seenIds = new Set()
	const records = []

	ids.forEach(id => {
		const normalizedId = sanitizeVal(id)
		if (seenIds.has(normalizedId)) return
		seenIds.add(normalizedId)

		const matches = index.recordsByValue.get(normalizedId)
		if (matches) records.push(...matches)
	})

	return createCollectionLike(entities, records)
}

export const createCollectionLike = (records, items) => {
	if (records.constructor === Array) return items
	return new records.constructor(items)
}

const isIndexableValue = val => {
	return val === null || ['string', 'number', 'boolean'].includes(typeof val)
}

const isIndexableQueryValue = val => {
	if (_.isArray(val)) return val.every(isIndexableValue)
	return isIndexableValue(val)
}

const isIndexableKey = key => {
	return key === 'id' || key.endsWith('_id') || key === 'date' || key === 'tableName'
}

const getIndexForKey = (records, key) => {
	let indexesByKey = indexedRecordsCache.get(records)
	if (!indexesByKey) {
		indexesByKey = new Map()
		indexedRecordsCache.set(records, indexesByKey)
	}

	let index = indexesByKey.get(key)
	if (index) return index

	index = buildIndexForKey(records, key)
	indexesByKey.set(key, index)
	return index
}

const buildIndexForKey = (records, key) => {
	const recordsByValue = new Map()

	records.forEach(record => {
		const value = sanitizeVal(record[key])
		if (!isIndexableValue(value)) return

		const matches = recordsByValue.get(value) || []
		matches.push(record)
		recordsByValue.set(value, matches)
	})

	return {recordsByValue}
}

const getRecordsFromIndex = (index, value) => {
	if (!_.isArray(value)) return index.recordsByValue.get(value) || []

	const seenRecords = new Set()
	const records = []
	value.forEach(item => {
		const matches = index.recordsByValue.get(sanitizeVal(item))
		if (!matches) return
		matches.forEach(record => {
			if (seenRecords.has(record)) return
			seenRecords.add(record)
			records.push(record)
		})
	})
	return records
}
